import {
  FETCH_EVENTS_BY_REQUEST_ID_SUCCESS,
  FETCH_INCIDENTS_BY_REQUEST_ID_SUCCESS,
  FETCH_BY_REQUEST_ID_RESET,
} from 'actions/flowFormSubmission';

const initialState = {
  events: [],
  incidents: [],
};

export default function flowFormSubmission(state = initialState, action) {
  switch (action.type) {
    case FETCH_INCIDENTS_BY_REQUEST_ID_SUCCESS:
      return {
        ...state,
        incidents: action.payload.data,
      };
    case FETCH_EVENTS_BY_REQUEST_ID_SUCCESS:
      return {
        ...state,
        events: action.payload.data,
      };
    case FETCH_BY_REQUEST_ID_RESET:
      return initialState;
    default:
      return state;
  }
}
